import React, { useState , useRef, useEffect} from 'react';


import { Engineering } from '@mui/icons-material';
import styles from './PinnedSubjectsDash.module.css';

import axios from 'axios';
import { MdPushPin } from "react-icons/md";

      
import { useGlobalState } from '../../../global_state_components/GlobalStateProvider.jsx';
import { axiosInstance } from '../../../../lib/axiosInstance.js';





function PinnedSubjectsDash() {
  const {pinnedSubjects, subject, setSubjectFn} = useGlobalState();

  /*
  function handleSubjectClick(e){
    //console.log("subject: " + e.currentTarget.textContent);
    //console.log("subject: " + e.currentTarget.getAttribute('name'));
    setSubject(e.currentTarget.getAttribute('name'));
  }*/

      
  return(
    <div className={styles.subject_div}>
      {/* <SlArrowLeft className={styles.arrow_size}/> */}
      {/*How to display the pinned subject here when you get it from the backend? Vinod told about web sockets that I have to 
      continuosly fetch form the backend (Or is it needed for this purpose? Isn't just needed for the booked names appearing on the calendar?).

      loop on array needed I guess.*/} 

      {
        pinnedSubjects.map(function(eachPinnedSubject, index){
          return(
            <div key={index} name={eachPinnedSubject} onClick={()=>setSubjectFn(eachPinnedSubject)} className={(eachPinnedSubject===subject)? styles.clicked_subject : styles.subject}>
              <MdPushPin className={styles.pin}/> 
              <p>{eachPinnedSubject}</p>
            </div>
          )
        })
      }

      {/*
      <div name='physics' onClick={setSubjectFn} className={(subject==='physics')? styles.clicked_subject : styles.subject}><MdPushPin className={styles.pin}/> <p>Physics</p></div>

      <div name='physics' onClick={setSubjectFn} className={(subject==='physics')? styles.clicked_subject : styles.subject}><MdPushPin className={styles.pin}/> <p>Physics</p></div>
      <div name='french' onClick={setSubjectFn} className={(subject==='french')? styles.clicked_subject : styles.subject }><MdPushPin className={styles.pin}/><p>French</p></div>
      <div name='guitar' onClick={setSubjectFn} className={(subject==='guitar')? styles.clicked_subject : styles.subject }><MdPushPin className={styles.pin}/><p>Guitar</p></div>
      <div name='mechanical' onClick={setSubjectFn} className={(subject==='mechanical')?styles.clicked_subject:styles.subject}><MdPushPin className={styles.pin}/><p>Mechanical Engineering</p></div>
      <div name='medicine' onClick={setSubjectFn} className={(subject==='medicine')?styles.clicked_subject:styles.subject}><MdPushPin className={styles.pin}/><p>Medicine</p></div>
      <div name='law' onClick={setSubjectFn} className={(subject==='law')?styles.clicked_subject:styles.subject}><MdPushPin className={styles.pin}/><p>Law</p></div>
      */}

      {/* <SlArrowRight className={styles.arrow_size}/> */}
    </div>
  )

}


export default PinnedSubjectsDash;
















/*
import axios from 'axios';
import { useEffect, useState } from 'react';

function App() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get('/data');
        setData(response.data); // Set the fetched data
        setLoading(false); // Stop the loading state
      } catch (error) {
        setError(error); // Handle any errors
        setLoading(false);
      }
    };

    fetchData(); // Call the async function
  }, []); // Empty array ensures the effect runs only once

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div>
      <h1>Data from Backend:</h1>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
}

export default App;
*/